import { getCookie, setCookie } from 'mlmi-library/utils/cookies'

$.fn.Splash = function(options) {
  let self = this
  self.has_been_displayed = false

  self.initialize_cookie = function() {
    if (getCookie('splash_displayed') == 'yes') {
      self.has_been_displayed = true
    }
  }

  self.display = function() {
    if (!self.has_been_displayed) {
      self.addClass('--fade-out');
      self.has_been_displayed = true
      setCookie('splash_displayed', 'yes', 24 * 60 * 60)
    } else {
      self.css('display', 'none');
    }
    $('html').addClass('--ready');
  }

  return function() {
    self.initialize_cookie()
    self.display()
    return self
  }()
}

export default {
  init() {
    $('.intro-splash').each(function() {
      $(this).Splash()
    })
  },
}
